import React, { Component } from "react";
import { TopBarComponent } from "./TopBarComponent";
import { SideBarComponent } from "./SideBarComponent";
import { SkeletonTheme } from "react-loading-skeleton";
import HelpPanel from "./Shared/HelpPanel";

export class AuthorisedLayout extends Component {
  static displayName = AuthorisedLayout.name;

  constructor(props) {
    super(props);
  }

  async componentDidMount() {}
  render() {
    return (
      <SkeletonTheme>
        <div className="wrapper">
          <TopBarComponent />
          <SideBarComponent />
          <div className="content-wrapper">{this.props.children}</div>
          <HelpPanel />
        </div>
      </SkeletonTheme>
    );
  }
}
